var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-wrapper" },
    [
      !_vm.useV2 && _vm.showSwitch
        ? _c("div", { staticClass: "rv-banner" }, [
            _c("i", { staticClass: "material-icons rv-banner__icon" }, [
              _vm._v("history"),
            ]),
            _c("span", { staticClass: "rv-banner__text" }, [
              _vm._v(_vm._s(_vm.$t("dash.reporting.legacy_banner_text"))),
            ]),
            _c(
              "button",
              {
                staticClass: "rv-banner__btn",
                on: {
                  click: function ($event) {
                    return _vm.switchVersion("2")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dash.reporting.switch_to_v2")) +
                    "\n      "
                ),
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("arrow_forward"),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm.useV2 && _vm.showSwitch
        ? _c("div", { staticClass: "rv-topbar" }, [
            _c(
              "button",
              {
                staticClass: "rv-topbar__btn",
                on: {
                  click: function ($event) {
                    return _vm.switchVersion("1")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("history")]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dash.reporting.switch_to_legacy")) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.useV2 ? _c("ReportingMain") : _c("ReportingLegacy"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }